export enum Locales {
  En = 'en',
  Kk = 'kk',
  Ru = 'ru',
}
